import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import MdText from '../../MdText';
import { MPopupTimer } from '../MPopupTimer';
import { MText } from '../../atoms/MText';
import { MBox } from '../../atoms/MBox';
import MFlexbox from '../../atoms/MFlexbox';

import IconClose from '../../atoms/IconClose';

const StyledPopupOfferHeaderCon = styled(MBox)`
  position: relative;
  border-bottom: 1px solid #babfc3;
  padding: 20px 35px 20px 35px;

  & .mr-offer-header-con__icon-close {
    background: transparent;
    position: absolute;
    border: none;
    padding: 16px;
    top: 4px;
    right: 4px;
  }

  & .Polaris-Icon {
    color: ${props => props.timerColor};
  }
`;

export const MPopupHeader = props => {
  const {
    offerHeaderContainerBackgroundColor,
    offerHeaderContainerPadding,
    offerHeaderContainerMargin,
    offerHeaderText,
    offerHeaderTextColor,
    offerHeaderFontSize,
    offerHeaderMobileFontSize,
    offerHeaderTextDecoration,
    offerHeaderFontStyle,
    offerHeaderFontWeight,
    offerHeaderFontFamily,
    offerHeaderTextAlignment,
    offerHeaderPadding,
    offerHeaderMargin,
    offerSubtitleText,
    offerSubtitleFontSize,
    offerSubtitleMobileFontSize,
    offerSubtitleFontStyle,
    offerSubtitleFontWeight,
    offerSubtitleTextColor,
    offerSubtitleTextDecoration,
    offerSubtitleFontFamily,
    offerSubtitleTextAlignment,
    offerSubtitlePadding,
    offerSubtitleMargin,
    isTimerDisabled,
    seconds,
    minutes,
    offerTimerText,
    timerColor,
    timerTextColor,
    timerTitleText,
    timerTitleFontSize,
    timerTitleMobileFontSize,
    timerTitleTextColor,
    timerTitleFontWeight,
    timerTitleFontStyle,
    timerTitleTextDecoration,
    timerTitleTextAlignment,
    timerTitleFontFamily,
    timerTitlePadding,
    timerTitleMargin,
    isPopupCloseButtonEnabled,
    onMinimizeClick,
  } = props;

  return (
    <StyledPopupOfferHeaderCon
      backgroundColor={offerHeaderContainerBackgroundColor}
      padding={offerHeaderContainerPadding}
      margin={offerHeaderContainerMargin}
      className="mr-popup-widget__offer-header-con"
      timerColor={timerTitleTextColor}
    >
      {isPopupCloseButtonEnabled && (
        <IconClose
          fontSize={16}
          color={offerHeaderTextColor}
          onClick={onMinimizeClick}
          className="mr-offer-header-con__icon-close"
        />
      )}
      <MdText
        fontSize={`${offerHeaderFontSize}px`}
        alignment={offerHeaderTextAlignment}
        color={offerHeaderTextColor}
        fontWeight=""
        fontFamily={offerHeaderFontFamily}
        padding={offerHeaderPadding}
        margin={offerHeaderMargin}
        className="mr-offer-header-con__header-text"
      >
        {offerHeaderText}
      </MdText>
      {offerSubtitleText && (
        <MdText
          fontSize={`${offerSubtitleFontSize}px`}
          alignment={offerSubtitleTextAlignment}
          color={offerSubtitleTextColor}
          fontWeight=""
          fontFamily={offerSubtitleFontFamily}
          padding={offerSubtitlePadding}
          margin={offerSubtitleMargin}
          className="mr-offer-header-con__subtitle-text"
        >
          {offerSubtitleText}
        </MdText>
      )}

      {!isTimerDisabled && (
        <MFlexbox
          ai="center"
          jc={timerTitleTextAlignment}
          padding={timerTitlePadding}
          margin={timerTitleMargin}
          className="mr-offer-header-con__popup-timer"
        >
          <MFlexbox ai="center" gap="4px">
            <img
              src="https://resources.monkcommerce.app/app-images/clock.svg"
              alt="clock"
              loading="lazy"
            />
            <MText
              fontSize={timerTitleFontSize}
              mobileFontSize={timerTitleMobileFontSize}
              color={timerTitleTextColor}
              fontStyle={timerTitleFontStyle}
              fontWeight={timerTitleFontWeight}
              textDecoration={timerTitleTextDecoration}
              fontFamily={timerTitleFontFamily}
              className="mr-popup-timer__title"
            >
              {timerTitleText}
            </MText>
          </MFlexbox>
          <MPopupTimer
            offerTimerText={offerTimerText}
            minutes={minutes}
            seconds={seconds}
            color={timerTextColor}
            fontSize={timerTitleFontSize}
            mobileFontSize={timerTitleMobileFontSize}
            fontStyle={timerTitleFontStyle}
            fontWeight={timerTitleFontWeight}
            textDecoration={timerTitleTextDecoration}
            fontFamily={timerTitleFontFamily}
          />
        </MFlexbox>
      )}
    </StyledPopupOfferHeaderCon>
  );
};

MPopupHeader.propTypes = {
  offerHeaderContainerBackgroundColor: PropTypes.string,
  offerHeaderContainerPadding: PropTypes.string,
  offerHeaderContainerMargin: PropTypes.string,
  offerHeaderText: PropTypes.string,
  offerHeaderTextColor: PropTypes.string,
  offerHeaderFontSize: PropTypes.string,
  offerHeaderMobileFontSize: PropTypes.string,
  offerHeaderTextDecoration: PropTypes.string,
  offerHeaderFontStyle: PropTypes.string,
  offerHeaderFontWeight: PropTypes.string,
  offerHeaderFontFamily: PropTypes.string,
  offerHeaderTextAlignment: PropTypes.string,
  offerHeaderPadding: PropTypes.string,
  offerHeaderMargin: PropTypes.string,
  offerSubtitleText: PropTypes.string,
  offerSubtitleTextColor: PropTypes.string,
  offerSubtitleFontSize: PropTypes.string,
  offerSubtitleMobileFontSize: PropTypes.string,
  offerSubtitleTextDecoration: PropTypes.string,
  offerSubtitleFontStyle: PropTypes.string,
  offerSubtitleFontWeight: PropTypes.string,
  offerSubtitleFontFamily: PropTypes.string,
  offerSubtitleTextAlignment: PropTypes.string,
  offerSubtitlePadding: PropTypes.string,
  offerSubtitleMargin: PropTypes.string,
  isTimerDisabled: PropTypes.bool,
  seconds: PropTypes.string,
  minutes: PropTypes.string,
  offerTimerText: PropTypes.string,
  timerColor: PropTypes.string,
  timerTextColor: PropTypes.string,
  timerTitleText: PropTypes.string,
  timerTitleFontSize: PropTypes.string,
  timerTitleMobileFontSize: PropTypes.string,
  timerTitleTextColor: PropTypes.string,
  timerTitleFontWeight: PropTypes.string,
  timerTitleFontStyle: PropTypes.string,
  timerTitleTextDecoration: PropTypes.string,
  timerTitleTextAlignment: PropTypes.string,
  timerTitleFontFamily: PropTypes.string,
  timerTitlePadding: PropTypes.string,
  timerTitleMargin: PropTypes.string,
  isPopupCloseButtonEnabled: PropTypes.bool,
  onMinimizeClick: PropTypes.func,
};
